/*
==========================================================
ZARI STORY - REAL PHOTOSWIPE PRODUCT GALLERY
Images + videos open inside PhotoSwipe popup.
==========================================================
*/

import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe-lightbox.esm.min.js';

function getBestImageUrl(img) {
  if (!img) return '';

  if (img.srcset) {
    const candidates = img.srcset
      .split(',')
      .map((item) => {
        const parts = item.trim().split(/\s+/);
        return {
          url: parts[0],
          width: parseInt(parts[1], 10) || 0
        };
      })
      .filter((item) => item.url);

    if (candidates.length) {
      candidates.sort((a, b) => b.width - a.width);
      return candidates[0].url;
    }
  }

  return img.currentSrc || img.src || '';
}

function getImageSize(img) {
  return {
    width: img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 1600,
    height: img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 2400
  };
}

function isVideoOpener(opener) {
  return (
    opener &&
    (
      opener.classList.contains('product__modal-opener--video') ||
      opener.classList.contains('product__modal-opener--external_video')
    )
  );
}

function getVideoHtml(opener) {
  const container = opener.closest('.product-media-container');
  if (!container) return '';

  const template = container.querySelector('template');
  if (!template) return '';

  return `
    <div class="zari-pswp-video-outer">
      <div class="zari-pswp-video-wrap">
        ${template.innerHTML}
      </div>
    </div>
  `;
}

function stopAllVideos() {
  document.querySelectorAll('.pswp video').forEach((video) => {
    video.pause();
  });

  document.querySelectorAll('.pswp iframe').forEach((iframe) => {
    iframe.src = iframe.src;
  });
}

if (!window.zariPhotoSwipeInitialized) {
  window.zariPhotoSwipeInitialized = true;

  const lightbox = new PhotoSwipeLightbox({
    gallery: 'media-gallery',
    children: '.product__modal-opener',

    pswpModule: () =>
      import('https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js'),

    bgOpacity: 0.92,
    showHideAnimationType: 'zoom',

    initialZoomLevel: 'fit',
    secondaryZoomLevel: 2.2,
    maxZoomLevel: 4,

    wheelToZoom: true,
    loop: true,
    arrowKeys: true,

    padding: {
      top: 30,
      bottom: 30,
      left: 16,
      right: 16
    },

    imageClickAction: 'zoom',
    tapAction: 'toggle-controls',
    doubleTapAction: 'zoom',
    bgClickAction: 'close'
  });

  lightbox.addFilter('itemData', (itemData) => {
    const opener = itemData.element;

    if (!opener) return itemData;

    if (isVideoOpener(opener)) {
      return {
        html: getVideoHtml(opener),
        width: 1,
        height: 1
      };
    }

    const img = opener.querySelector('.product__media img');
    if (!img) return itemData;

    const size = getImageSize(img);

    return {
      src: getBestImageUrl(img),
      width: size.width,
      height: size.height,
      alt: img.alt || ''
    };
  });

  lightbox.on('beforeOpen', () => {
    document.body.classList.add('zari-pswp-open');
  });

  lightbox.on('change', () => {
    stopAllVideos();
  });

  lightbox.on('close', () => {
    stopAllVideos();
    document.body.classList.remove('zari-pswp-open');
  });

  lightbox.on('contentAppend', (e) => {
    const video = e.content.element?.querySelector?.('video');

    if (video) {
      video.controls = true;
      video.playsInline = true;
      video.autoplay = false;
      video.muted = false;
    }
  });

  lightbox.init();
}